export const config = Object.assign({}, window['config'] || {} );
